import { useMemo } from 'react';
import { SYSTEM_WORKSPACE_PREFIX } from './utils';
import { useOrganizationWidePreferences } from 'kineticUtils/hooks';
import { Workspace } from './WorkspaceContext';

export const useSystemWorkspaces = () => {
  const { data, ...rest } = useOrganizationWidePreferences<Workspace>();

  const systemWorkspaces: Workspace[] = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter((pref) => pref.key.includes(SYSTEM_WORKSPACE_PREFIX))
      .map(({ value }) => value as Workspace);
  }, [data]);

  return {
    systemWorkspaces,
    ...rest,
  };
};
